interface ToggleSwitchProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
}

export function ToggleSwitch({ enabled, onChange, disabled = false, size = 'md' }: ToggleSwitchProps) {
  const trackClass = size === 'sm'
    ? 'h-5 w-9'
    : 'h-6 w-11';
  const thumbClass = size === 'sm'
    ? 'h-4 w-4'
    : 'h-5 w-5';
  const translateClass = size === 'sm'
    ? (enabled ? 'translate-x-4' : 'translate-x-0')
    : (enabled ? 'translate-x-5' : 'translate-x-0');

  return (
    <button
      type="button"
      onClick={() => !disabled && onChange(!enabled)}
      disabled={disabled}
      className={`relative inline-flex flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${trackClass} ${
        disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer'
      } ${enabled && !disabled ? 'bg-blue-600' : 'bg-gray-200'}`}
      role="switch"
      aria-checked={enabled}
    >
      <span
        className={`pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${thumbClass} ${translateClass}`}
      />
    </button>
  );
}
